import { IWidgetsListRequest, WidgetsData } from 'api/types/widgets';
import { createAsyncSlice } from 'slices/createAsyncSlice';

type WidgetSliceState = {
  data: WidgetsData;
};
const initialState: WidgetSliceState = {
  data: [],
};
const WIDGET_SLICE = 'WIDGET_SLICE';
export const widgetsSlice = createAsyncSlice<WidgetSliceState, IWidgetsListRequest>(WIDGET_SLICE, initialState);

export const widgetsReducer = widgetsSlice.reducer;
export const widgetsActions = widgetsSlice.actions;
